export default __webpack_public_path__ + "static/media/upgodwin.83cd9a29.jpeg";